import { ENV, trpc } from "@src/utils"
import { Pressable, View } from "react-native"
import { MenuActions, Text, Image } from "@src/components"
import { router } from "expo-router"
import { ar } from "@src/i18n"

type BrandCardProps = {
  brand: {
    id: number
    name: string
    images?: { key: string; thumbhash?: string | null }[]
  }
  onRefresh: () => void
  onEdit: () => void
}

export function BrandCard({ brand, onRefresh, onEdit }: BrandCardProps) {
  const deleteBrand = trpc.brands.delete.useMutation()

  const handleDelete = async () => {
    try {
      await deleteBrand.mutateAsync({ id: brand.id })
      onRefresh()
      return undefined
    } catch (error) {
      return error instanceof Error ? error.message : ar.deleteBrandError
    }
  }

  const isPending = deleteBrand.isPending

  return (
    <View className="mb-2 py-2 px-2 relative">
      <Pressable onPress={() => router.push(`/dashboard/brand/${brand.id}`)}>
        <Image
          source={`${ENV.R2_URL}/${brand.images?.at(-1)?.key}`}
          style={{ height: 18 * 4, aspectRatio: 2.25, backgroundColor: "white" }}
          contentFit="contain"
          recyclingKey={brand.id.toString()}
          transition={250}
          loading="lazy"
          cachePolicy="memory"
        />
        <Text className="text-lg font-bold absolute top-2 start-2 bg-white px-2 py-1 shadow-lg">{brand.name}</Text>
      </Pressable>
      <MenuActions itemName={brand.name} onDelete={handleDelete} onEdit={onEdit} isPending={isPending} />
    </View>
  )
}
